import { defineStore } from "pinia"

export const useContentMenuStore = defineStore("contentMenuStore", {
  state: () => ({
    subject: null,
    grade: null,
    section: null,
    tab: "subjects",
  }),

  actions: {
    setTab(tab: "subjects" | "grades" | "smart-files") {
      this.tab = tab
    },

    setSubject(subject: any) {
      this.subject = subject
      this.grade = null
      this.section = null
    },

    setGrade(grade: any) {
      this.grade = grade
      this.section = null
    },

    setSection(section: any) {
      this.section = section
    },

    reset() {
      this.tab = "subjects"
      this.subject = null
      this.grade = null
      this.section = null
    },
  },
})
